import { render, staticRenderFns } from "./PortalUploadButton.vue?vue&type=template&id=2e37b28b&scoped=true&"
import script from "./PortalUploadButton.vue?vue&type=script&lang=js&"
export * from "./PortalUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./PortalUploadButton.vue?vue&type=style&index=0&id=2e37b28b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37b28b",
  null
  
)

export default component.exports